export enum HubStatuses {
  NotStarted = "unstarted",
  Connected = "connected",
  Disconnected = "disconnected",
  Reconnecting = "reconnecting",
  Reconnected = "reconnected",
}
